import { useEffect } from 'react';
import useUser from 'src/hooks/useUser';

const useSkeletonCleanup = (loadingOverride?: boolean) => {
  const { loading: userLoading } = useUser();
  const loading = loadingOverride ?? userLoading;

  useEffect(() => {
    if (loading) return;

    const skeleton = document.getElementById('skeleton-loader');
    if (!skeleton) return;

    // Ensure browser has painted the content beneath
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        skeleton.classList.add('fade-out');

        skeleton.addEventListener(
          'transitionend',
          () => {
            skeleton.remove();
          },
          { once: true }
        );

        // Fallback if transition doesn't fire
        setTimeout(() => {
          if (document.contains(skeleton)) {
            skeleton.remove();
          }
        }, 500);
      });
    });
  }, [loading]);
};

export default useSkeletonCleanup;
